import { useState } from "react";
import { SSO_HOST_UX_URL_REDIRECT } from "utils/environmentVariables";
import { StyledTile, StyledWrapper } from "./AuthenticationTile.module";
import { Icon } from "@vds/icons";
import Title from "components/typography/Title/Title";
import { SignInForm } from "features";
import {supportsStorage} from "../../../utils";

export interface AuthenticationTileInterface {
  sso?: boolean;
}

const SSO_LOGIN_LOGGED_KEY = 'ssoLoginLogged';

if (supportsStorage("sessionStorage")) {
  const sso_log_key = sessionStorage.getItem(SSO_LOGIN_LOGGED_KEY);
  if (sso_log_key) {
    sessionStorage.removeItem(SSO_LOGIN_LOGGED_KEY);
  }
}

const AuthenticationTile = ({ sso }: AuthenticationTileInterface) => {
  const [expanded, _setExpanded] = useState(false),
    setExpanded = () => {
      _setExpanded(!expanded);
    };

  return (
    <>
      {sso ? (
        <StyledTile className="sso">
          <a href={SSO_HOST_UX_URL_REDIRECT}>
            <Title size="medium" bold color="#EE0000">
              <>
                Verizon <br /> employees
              </>
            </Title>
            <Icon name="right-arrow" size={45} color="#EE0000" />
          </a>
        </StyledTile>
      ) : (
        <StyledWrapper>
          <StyledTile
            className={expanded ? `expanded` : ``}
            onClick={setExpanded}
          >
            <Title size="medium" bold color="#EE0000">
              <>
                Approved <br />
                agencies & <br />
                vendors
              </>
            </Title>
            <Icon name="right-arrow" size={45} color="#EE0000" />
          </StyledTile>

          <SignInForm expanded={expanded} setExpanded={setExpanded} />
        </StyledWrapper>
      )}
    </>
  );
};

export default AuthenticationTile;
